<template>
    <div class="results">
        <div class="container">
            <div class="results-container">
                <div class="results-title">
                    <button class="back-button" @click="$router.back()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28.146" height="18.999" viewBox="0 0 28.146 18.999">
                            <path d="M12.7,12.141H0V6.86H12.7V0L28.146,9.5,12.7,19Z" transform="translate(28.146 19.002) rotate(180)" fill="#fff"/>
                        </svg>

                        Back to Questions
                    </button>
                    <h2 class="title">
                        <span class="small">You've Got options</span>
                        <span class="large">
                            <span>Program </span><br />
                            <span>Results</span>
                        </span>
                    </h2>
                </div>
                <div class="primary-results">
                    <div class="intro">
                        <h2 ref="start">Start Here</h2>
                        <p>
                            Based on your goals, you might consider these options:
                        </p>
                    </div>
                    <ul class="primary-list">
                        <li
                            v-for="result in responses.primary.links"
                            class="result-item"
                            :key="result.title"
                        >
                            <a v-if="result.url" :href="result.url" target="_blank">{{
                                result.title
                            }}</a>
                            <strong v-else>{{ result.title }}</strong>
                            <br />
                            <p v-if="result.description" class="degree-description">
                                {{ result.description }}
                            </p>
                            <span>{{ result.subtitle }}</span>
                        </li>
                    </ul>
                    <small v-if="footnote" class="footnote">
                        <strong v-if="footnote.prerequisite">Pre-requisites: </strong>
                        <span v-html="getFootnote( footnote )"></span>
                    </small>
                </div>
                <div class="secondary-results">
                    <h2>Look Ahead</h2>
                    <p v-if="responses.secondary">
                        After completion, you may continue your journey with the Faculty of Education:
                    </p>
                    <ul v-if="responses.secondary" class="secondary-list">
                        <li
                            v-for="result in responses.secondary.links"
                            :key="result.title"
                            class="secondary-item"
                        >
                            <a v-if="result.url" :href="result.url" target="_blank">{{
                                result.title
                            }}</a>
                            <strong v-else>{{ result.title }}</strong>
                            <br />
                            <span>{{ result.subtitle }}</span>
                        </li>
                    </ul>

                    <p>
                        See how students and alumni apply their knowledge,
                        skills and experiences in teaching, research and other
                        professional careers at
                        <a href="https://sfu.ca/education" target="_blank">sfu.ca/education</a>
                    </p>

                    <button @click="restart" class="button button-restart">
                        Retake Quiz
                    </button>
                </div>
            </div>
            <!-- <Data /> -->
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import { mapState, mapMutations } from "vuex";
    import Data from "./Data";
    import responses from "../pathways/results";
    // import Header from "../components/Header.vue";

    export default {
        name: "Results",
        mounted() {
            this.$refs.start.focus()
        },
        methods: {
            ...mapMutations(["resetResults"]),

            restart() {
                this.resetResults();
                if (this.$route.path !== "/pathway/0") {
                    this.$router.push("/pathway/0");
                }
            },

            getFootnote( obj ) {

                const { links } = obj;

                const items = links && links.map( link => {
                    return `<a class="link" href="${link.url}" target="_blank">${link.text}</a>`
                })

                let newText = obj.text;

                if( items ) {
                    items.forEach( (item, i) => {
                        const index = `{${i}}`;
                        newText = obj.text.replace( index, item );
                    });
                }

                return newText;
            }
        },
        computed: {
            ...mapState({
                results: (state) => state.results,
            }),

            responses() {
                const length = this.results.length;

                // the last item in the results array
                const resultsItem = this.results[length - 1];
                // console.this.results
                // console.log({ resultsItem });

                if (resultsItem.type == "checkbox") {

                    const responseItem = responses.find(
                        (response) => response.id == resultsItem.key
                    );

                    const filteredPrimaryOptions =
                        responseItem.primary.links.length > 1 ? responseItem.primary.links.filter((link) => {
                            return resultsItem.selection.find(
                                (item) => item == link.title
                            );
                        }) : responseItem.primary.links;

                    // console.log({ filteredPrimaryOptions })

                    // const primaryLinks = responseItem.areasAsSubBullets ? responseItem.primary.links : filteredPrimaryOptions

                    // if(responseItem.areasAsSubBullets) {
                    //     primaryLinks[0].degrees = responseItem.primary.degrees.filter((degree) => {
                    //         return resultsItem.selection.find(
                    //             (item) => item == degree.title
                    //         );
                    //     }).map(degree => {
                    //         return {
                    //             name: degree.title
                    //         }
                    //     });
                    // }


                    const result = {
                        key: responseItem.id,
                        primary: {
                            links: filteredPrimaryOptions,
                        },
                    }

                    // edit how this works by filtering above??
                    if (responseItem.secondary) {
                        result.secondary = responseItem.secondary
                    }

                    return result;
                } // { responses } is imported above

                return responses.find(
                    (response) => response.id == resultsItem.selection
                );
            },

            footnote() {
                const length = this.results.length;

                console.log({ responses });
                // the last item in the results array
                const resultsItem = this.results[length - 1];
                console.log({ resultsItem });
                const responseItem = responses && responses.find(
                    (response) => {
                        if( !Array.isArray(resultsItem.selection)) {
                            return response.id == resultsItem.selection
                        }
                        return response.id == resultsItem.key
                    }
                );
                console.log({ responseItem });
                return responseItem && responseItem.footnote || null;
            }
        },
    };
</script>

<style scoped lang="scss">
    .results {
        /* background: var(--c-red); */
        background: #fff;
        /* min-height: 100vh; */
        padding-top: 2rem;
        color: var(--c-black);
    }

    .title {
        margin: 0;
        padding: 0;
        margin-bottom: 1rem;
    }

    .title small {
        font-size: 65%;
        display: block;
    }

    .title {
        font-family: var(--font-countach);
        text-transform: uppercase;
        position: relative;
        color: var(--c-red);
        background: #fff;
    }

    .title .small {
        font-family: var(--font-pdf);
        font-weight: bold;
        font-size: 18px;
        display: inline-block;
        line-height: 1.4;
        margin-bottom: 12px;
    }

    .title .large {
        font-size: 70px;
        display: block;
        position: relative;
        line-height: 60px;
        background: #fff;
        z-index: 1;
    }

    @media (min-width: 768px) {
        .title .large {
            font-size: 96px;
            line-height: 80px;
        }
    }

    @media (min-width: 1100px) {
        .title .large {
            font-size: 132px;
            line-height: 112px;
        }
    }

    .title .large span {
        position: relative;
        z-index: 10;
    }

    h2 {
        font-family: var(--font-pdf);
        text-transform: uppercase;
        font-size: 20px;
        font-weight: 800;
    }

    .results-container {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }

    @media (min-width: 900px) {
        .results-container {
            flex-wrap: nowrap;
            justify-content: space-between;
            padding-top: 3rem;
        }
    }

    .results-container a {
        color: var(--c-link);
    }

    .results-container a:hover,
    .results-container a:focus {
        text-decoration: none;
    }

    .result-item {
        list-style-type: square;
        color: var(--c-black);
    }

    .result-item.has-sub-list {
        list-style: none;
        margin-bottom: 2rem;
    }

    .has-sub-list ul {
        margin-top: 1rem;
    }
    .has-sub-list li  {
        list-style-type: square;
        color: var(--c-black);
    }

    .result-item::marker,
    .result-item li::marker {
        color: var(--c-red);
        font-size: 28px;
        line-height: 32px;
    }

    .result-item span {
        font-size: 80%;
    }

    .primary-results {
        padding: 0 2rem;
        width: 100%;
        position: relative;
    }

    .intro {
        color: var(--c-black);
    }

    .primary-list {
        padding: 3rem 0 1rem;
    }

    .secondary-results {
        background: var(--c-light-grey);
        padding: 2rem;
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 10;
    }

    .secondary-results p a {
        font-weight: 600;
    }

    .secondary-results:before {
        content: "";
        background: var(--c-light-grey);
        position: absolute;
        height: 300vh;
        width: 150vw;
        left: -50vw;
        top: 0;
        z-index: -1;
    }

     @media (min-width: 900px) {
        .primary-results {
            width: 30%;
            padding: 0rem 3rem;
        }

        .secondary-results {
            width: 30%;
            padding: 0rem 3rem 1rem 3rem;
        }

        .secondary-results:before {
            content: "";
            background: var(--c-light-grey);
            height: 300vh;
            width: 50vw;
            left: 0;
            top: -50vh;
            z-index: -1;
        }
     }

     .footnote {
         display: block;
         padding-bottom: 3rem;
     }


    .results-title {
        width: 100%;
    }

    @media (min-width: 900px) {
        .results-title {
            width: auto;
        }
    }

    @media (min-width: 1100px) {
        .primary-results {
            width: 30%;
            /* padding-right: 0; */
            padding: 2rem 4rem 1rem 4rem;
            transform: translateY(0);
            margin: 0;
        }

        .secondary-results {
            padding: 2rem 4rem;
        }

        .intro {
            padding-left: 0;
        }
    }

    .results-container p {
        font-size: 18px;
    }

    .results-container li {
        margin-bottom: 1rem;
        font-size: 22px;
    }

    .secondary-results li {
        font-size: 18px;
    }

    .secondary-list {
        padding-left: 0;
        list-style-type: square;
    }

    .secondary-item::marker {
        color: var(--c-red);
        font-size: 24px;
    }

    .degree-description {
        margin-top: 0.5rem;
    }


    .scroll-text {
        font-family: var(--font-pdf);
        color: var(--c-black);
        font-size: 12px;
        font-weight: 600;
        position: absolute;
        bottom: -200px;
        left: 0px;
        width: 70px;
        text-align: center;
        text-transform: none;
    }

    .button-restart {
        font-size: 1.5rem;
        position: relative;
        z-index: 100;
        width: 100%;
        display: block;
        padding: 1rem 3rem;
        margin-top: 3rem;
        font-weight: bold;
        text-transform: uppercase;
        cursor: pointer;
        background: var(--c-red);
        color: #fff;
        border: 1px solid var(--c-red);
        font-family: var(--font-pdf);
    }

    .button-restart:hover,
    .button-restart:focus {
        color: var(--c-red);
        background: #fff;
    }

    @media (min-width: 900px) {
        .scroll-text {
            display: none;
        }

        .button-restart {
            display: none;
        }
    }

    .back-button {
        border: none;
        padding: 8px 16px;
        background: var(--c-link);
        color: #fff;
        border-radius: 40px;
        font-weight: 800;
        margin-bottom: 3rem;
        font-size: 18px;
        font-family: var(--font-pdf);
        cursor: pointer;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;

        &:focus {
            background: var(--c-red);
        }
    }

    @media (min-width: 900px) {
        .back-button {
            width: auto;

            &:hover {
                background: var(--c-red);
            }
        }
    }

    strong {
        font-weight: 600;
    }
</style>
